import React from 'react';
import { Flex } from '@chakra-ui/react';
import { IFormFieldState } from '../../../FormFieldSet';
import SimpleFieldHeader from '../common/SimpleFieldHeader';
import { DateEmptyState } from './DateEmptyState';
import { DateDisplay } from './DateDisplay';
import { FormFieldDate } from '.';
interface SimpleDateProps {
  formFieldState: IFormFieldState;
  config: FormFieldDate;
}

const SimpleDate: React.FC<SimpleDateProps> = ({ formFieldState }) => {
  return (
    <Flex flexDirection="column" gap={2}>
      <SimpleFieldHeader {...formFieldState} />
      {formFieldState.value ? (
        <DateDisplay value={formFieldState.value as string} />
      ) : (
        <DateEmptyState />
      )}
    </Flex>
  );
};

export default SimpleDate;
